import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    header: {
        id: 'swap.page.header',
        defaultMessage: 'Swap crypto',
    },
})
